import { ValidateContact } from "@/util/ValidationUtil";

export class InspectorAdminReqDto {
    /**
     * 점검 사용자 uuid
     * */
    userUuid: string;

    /**
     * 점검 사용자 ID
     * */
    userId: string;

    /**
     * 점검 사용자 이름
     * */
    firstName: string;

    /**
     * 점검 사용자 비밀번호
     * */
    password: string;

    /**
     * 점검 사용자 소속
     * */
    companyName: string;

    /**
     * 점검 사용자 핸드폰 번호
     * */
    @ValidateContact("핸드폰 번호")
    phone: string;

    /**
     * 점검 사용자 권한
     * */
    role: string;

    /**
     * 가입 날짜
     * */
    createdAt: string;
}